import { DOCUMENT } from '@angular/common';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

export const telaUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const document = inject(DOCUMENT);
  let destinoApi = false;

  try {
    const base = new URL(environment.apiUrl || '/', document.baseURI);
    const destino = new URL(req.url, document.baseURI);
    const caminhoBase = base.pathname.replace(/\/$/, '');
    // apiUrl é a base do servidor; restringir também /api evita enviar a origem para assets no mesmo host.
    const caminhoApi = `${caminhoBase}/api`;
    destinoApi = destino.origin === base.origin
      && (destino.pathname === caminhoApi || destino.pathname.startsWith(`${caminhoApi}/`));
  } catch {
    // URLs não resolvíveis não recebem informação da navegação.
  }

  return next(destinoApi ? req.clone({ setHeaders: { 'X-Tela-Url': router.url } }) : req);
};
